/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { Col, Empty, Pagination, Row } from 'antd';
import { ColumnGroupType, ColumnType } from 'antd/lib/table';
import CircularProgress from 'components/CircularProgress';
import { get, isObjectLike } from 'lodash';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { GeneralFunction } from 'types/common';

import { DataEntity, ITableProps } from './types';

const RowContainerStyled = styled(Col)<{ $isLastItem?: boolean; $isFirstItem?: boolean }>`
  padding: 10px 0;
  display: flex;
  align-items: center;
  border-bottom: ${({ $isLastItem }) => ($isLastItem ? 'none' : '1px solid #e8e8e8')};
  border-top: ${({ $isFirstItem }) => ($isFirstItem ? 'none' : 'none')};
`;

export const EmptyDataContainerStyled = styled.div`
  background-color: white;
  color: rgba(0, 0, 0, 0.25);
  .ant-empty-normal {
    color: inherit;
  }
`;
const ResponsiveTableRow = <T extends DataEntity>(props: {
  dataSource: any;
  column: ColumnGroupType<T> | ColumnType<T>;
  index: number;
  isLastItem: boolean;
  isFirstItem: boolean;
  onClick?: GeneralFunction;
  nullRender?: string;
}) => {
  const { column, dataSource, index, isLastItem, onClick, isFirstItem, nullRender } = props;
  const columnIndex = get(column, 'dataIndex');
  const columnData = column?.render?.(dataSource[columnIndex], dataSource, index);
  return !columnData && !column.title ? null : (
    <>
      {column.title && (
        <RowContainerStyled
          onClick={onClick}
          className='responsive-table-left-col'
          $isFirstItem={isFirstItem}
          $isLastItem={isLastItem}
          span={10}
          style={{ paddingRight: 15, paddingLeft: 15 }}>
          {column.title}
        </RowContainerStyled>
      )}
      <RowContainerStyled
        style={{ paddingRight: 15, justifyContent: column.title ? undefined : 'center' }}
        className='responsive-table-right-col'
        onClick={onClick}
        $isFirstItem={isFirstItem}
        $isLastItem={isLastItem}
        span={column.title ? 14 : 24}>
        {columnData !== undefined
          ? columnData || nullRender
          : !isObjectLike(dataSource[columnIndex])
          ? dataSource[columnIndex] || nullRender
          : nullRender}
      </RowContainerStyled>
    </>
  );
};

const ResponsiveMobileTable = <T extends DataEntity>(props: ITableProps<T>) => {
  const { dataSource, columns, loading, responsiveFullBordered, onRow, onChange, pagination, nullRender } = props;
  const rowBorder = '1px solid #bab6b6';

  const onChangePagination = useCallback(
    (page: number) => {
      onChange?.(
        {
          current: page,
        },
        null as any,
        null as any,
        {
          action: 'paginate',
          currentDataSource: dataSource as T[],
        },
      );
    },
    [onChange],
  );

  const generateResponsiveTable = (data: Record<string, any>, columnIndex: number) => (
    <Row
      style={{
        flexWrap: 'wrap',
        border: rowBorder,
        borderBottom: columnIndex + 1 === dataSource?.length ? rowBorder : 'none',
      }}
      className=''
      key={data.key}>
      {columns?.map((col, index) => (
        <ResponsiveTableRow
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          dataSource={data}
          column={col}
          index={index}
          isLastItem={index === columns.length - 1 && !responsiveFullBordered}
          isFirstItem={index === 0 && !responsiveFullBordered}
          onClick={onRow?.(data as any)?.onClick}
          nullRender={nullRender}
        />
      ))}
    </Row>
  );
  return (
    <div className='w-full h-full'>
      {loading && (
        <div className='min-w-full min-h-full'>
          <CircularProgress />
        </div>
      )}
      {dataSource?.map(generateResponsiveTable)}
      {!loading && (!dataSource || dataSource.length === 0) && (
        <EmptyDataContainerStyled className='gx-p-2 gx-responsive-table'>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </EmptyDataContainerStyled>
      )}
      {pagination && (
        <div className='mt-4 flex items-center justify-center'>
          <Pagination {...pagination} onChange={onChangePagination} />
        </div>
      )}
    </div>
  );
};

export default ResponsiveMobileTable;
